import { useState, useEffect } from 'react';

export const useCursor = () => {
  const [cur, setCur] = useState({ x: -200, y: -200 });
  const [hov, setHov] = useState(false);
  const [active, setActive] = useState(false); // true once real mouse movement is detected

  // Track real mouse movement — works correctly on hybrid devices
  // (touchscreen laptops) that report pointer:coarse even with a
  // mouse attached, unlike a static matchMedia check.
  useEffect(() => {
    const mv = e => {
      setCur({ x: e.clientX, y: e.clientY });
      setActive(true);
    };
    const onTouch = () => setActive(false);

    document.addEventListener("mousemove", mv);
    document.addEventListener("touchstart", onTouch, { passive: true });

    return () => {
      document.removeEventListener("mousemove", mv);
      document.removeEventListener("touchstart", onTouch);
    };
  }, []);

  useEffect(() => {
    const on = () => setHov(true);
    const off = () => setHov(false);
    const els = document.querySelectorAll("a,button,.pjcard,.sbox,.efeat,.pcard,.service-card,.case-card,.store-card");
    els.forEach(el => {
      el.addEventListener("mouseenter", on);
      el.addEventListener("mouseleave", off);
    });
    return () => {
      els.forEach(el => {
        el.removeEventListener("mouseenter", on);
        el.removeEventListener("mouseleave", off);
      });
    };
  }, []);

  return { cur, hov, active };
};